import 'css-chunksrc/client/scenes/optimizedGantt/calendar/months/styles.scss';export default {
  "months": "_months_1a0t8_1",
  "month": "_month_1a0t8_1"
};